module.exports = __webpack_public_path__ + "static/img/qr2.6271fa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr2.png
// module id = 3vm8
// module chunks = 1